var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e24725dc-0b44-4ff1-bec8-922bca6ca641",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1685.69 841.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".f8b12798-c6e2-40ac-a3d0-6225d73b34e3{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "aabe3691-848d-4d90-ac65-e1cfabe82afc",
    "data-name": "rightlapel",
    className: "f8b12798-c6e2-40ac-a3d0-6225d73b34e3",
    d: "M995.81,668.4l50.73,48.32a1.74,1.74,0,0,1,.33,2.1L920.63,953.94a1.76,1.76,0,0,1-3.22-1.36l70.5-224.69a60.42,60.42,0,0,0,.56-34.23l-5-17.88A7.44,7.44,0,0,1,995.81,668.4Z",
    transform: "translate(-99.31 -477.92)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "bf71a687-5822-4112-b585-cf9b1d1683a0",
    "data-name": "rightcollar",
    className: "f8b12798-c6e2-40ac-a3d0-6225d73b34e3",
    d: "M908.8,699.94a10.26,10.26,0,0,1,5.51-6.24l31.94-14.64c3-1.36,7-3.77,8.36-6.76l5.87-12a2,2,0,0,1,3.59.43l5.72,17.11a11.82,11.82,0,0,1-5.45,14.09l-57.47,32.48Z",
    transform: "translate(-99.31 -477.92)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "f0b8a4f7-67b8-4c9a-b542-79b54b62e59b",
    "data-name": "leftlapel",
    className: "f8b12798-c6e2-40ac-a3d0-6225d73b34e3",
    d: "M805.79,675.78l-5,17.88a60.34,60.34,0,0,0,.57,34.23l70.49,224.69a1.76,1.76,0,0,1-3.22,1.36L742.42,718.82a1.75,1.75,0,0,1,.34-2.1l50.73-48.32A7.44,7.44,0,0,1,805.79,675.78Z",
    transform: "translate(-99.31 -477.92)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "af791853-2878-40e1-bb87-316e528275b0",
    "data-name": "leftcollar",
    className: "f8b12798-c6e2-40ac-a3d0-6225d73b34e3",
    d: "M882.42,724.38,825,691.9a11.83,11.83,0,0,1-5.46-14.09l5.72-17.11a2,2,0,0,1,3.6-.43l5.86,12c1.31,3,5.39,5.4,8.36,6.76L875,693.7a10.23,10.23,0,0,1,5.51,6.24Z",
    transform: "translate(-99.31 -477.92)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "b21dc5d3-6fc2-434e-bc0a-0fccbca53176",
    "data-name": "topbutton",
    className: "f8b12798-c6e2-40ac-a3d0-6225d73b34e3",
    d: "M906.25,765.11a11.87,11.87,0,1,1-11.87-11.87A11.87,11.87,0,0,1,906.25,765.11Z",
    transform: "translate(-99.31 -477.92)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "f74e06ae-0eb3-44cd-893c-23c4c05db415",
    "data-name": "bottombutton",
    className: "f8b12798-c6e2-40ac-a3d0-6225d73b34e3",
    d: "M906.25,809.19a11.87,11.87,0,1,1-11.87-11.87A11.87,11.87,0,0,1,906.25,809.19Z",
    transform: "translate(-99.31 -477.92)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "f7166565-5bd1-429b-a68e-2ff4e13c86b8",
    "data-name": "righteye",
    className: "f8b12798-c6e2-40ac-a3d0-6225d73b34e3",
    d: "M916.72,522a26,26,0,0,1,52,0Z",
    transform: "translate(-99.31 -477.92)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "b3c07966-181c-4d7d-bd45-e06e6f084828",
    "data-name": "monocle",
    className: "f8b12798-c6e2-40ac-a3d0-6225d73b34e3",
    d: "M847.73,477.92a33.89,33.89,0,0,0-33.82,32.52l-.18,0,.16,1.58c0,1,.05,1.93.14,2.88.12,9.45-2.34,39.91-38.32,48l-1.68.37,1.76,7.84,1.68-.38c28.17-6.34,38.63-25,42.44-39.74a33.84,33.84,0,1,0,27.82-53.1ZM822,513.81c0-1-.06-1.78-.09-2.16a25.94,25.94,0,1,1,.09,2.16Z",
    transform: "translate(-99.31 -477.92)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "bdf08e43-7140-4e91-a2fe-700f76f4c6a8",
    "data-name": "mustache",
    className: "f8b12798-c6e2-40ac-a3d0-6225d73b34e3",
    d: "M970.15,605.56c-21.48,29.25-72.58-2.54-74.42-18.68-1.83,16.14-52.93,47.93-74.41,18.68-21.88-29.79,7.91-37.24,7.91-37.24s-11.17,4.66-7,14.43,11.64,8.38,18.15,7.91,33.51-25.13,43.75-25.6c9.17-.41,11.25,4,11.58,5,.34-.93,2.42-5.36,11.58-5,10.24.47,37.24,25.14,43.76,25.6s14,1.86,18.15-7.91-7-14.43-7-14.43S992,575.77,970.15,605.56Z",
    transform: "translate(-99.31 -477.92)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "a3cc651c-294c-4b1b-852a-28f30f77e871",
    "data-name": "nameA",
    className: "f8b12798-c6e2-40ac-a3d0-6225d73b34e3",
    d: "M228.29,1066.43,122.43,1274.17l-23.12,45.16h50.58L173,1274.17l5.27-10.32h100l5.26,10.32,23.12,45.16h50.59l-23.13-45.16Zm-26,150.3,26-51,26,51Z",
    transform: "translate(-99.31 -477.92)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "b173388a-f5b6-4158-898b-1e40b21a021c",
    "data-name": "nameL",
    className: "f8b12798-c6e2-40ac-a3d0-6225d73b34e3",
    d: "M445.43,1274.17l132.6.36v45.16H449.77a78.56,78.56,0,0,1-35.41-8.31,80.07,80.07,0,0,1-36.49-36.85,78.56,78.56,0,0,1-8.31-35.41V1066.79h45.16v176.67A36,36,0,0,0,445.43,1274.17Z",
    transform: "translate(-99.31 -477.92)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "e503a94b-a52f-4754-882e-7e0b4ec95df1",
    "data-name": "nameF",
    className: "f8b12798-c6e2-40ac-a3d0-6225d73b34e3",
    d: "M682.44,1066.43h185v45.16H682.8a23.28,23.28,0,0,0-23.13,23.12v23.48H822.26v45.17h-163v116h-44.8V1134.71C614.51,1097.14,644.86,1066.43,682.44,1066.43Z",
    transform: "translate(-99.31 -477.92)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "e4964298-1df8-406e-8a5c-f71556ae322f",
    "data-name": "nameR",
    className: "f8b12798-c6e2-40ac-a3d0-6225d73b34e3",
    d: "M1130.44,1135.07a69.2,69.2,0,0,0-19.87-48.41,67.71,67.71,0,0,0-48.06-19.87H902.82v252.9H948V1203.36h45.17a44.77,44.77,0,0,1,38.29,21.67l1.09,2.17,24.2,47.33,23.13,45.16h50.58l-23.13-45.16-36.12-71.9a60.22,60.22,0,0,0,19.5-5.42A68.47,68.47,0,0,0,1130.44,1135.07Zm-58.53,21a21.14,21.14,0,0,1-9.4,2.16l-114.53.37V1112h114.53a22.76,22.76,0,0,1,16.26,6.5,23.83,23.83,0,0,1,6.87,16.62A23,23,0,0,1,1071.91,1156Z",
    transform: "translate(-99.31 -477.92)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "a1c34174-bdd2-4685-8d5c-1f661cd591c3",
    "data-name": "nameE",
    className: "f8b12798-c6e2-40ac-a3d0-6225d73b34e3",
    d: "M1235.21,1066.43h184.62v45.16H1235.21a23.28,23.28,0,0,0-23.12,23.12v23.48h162.58v45.17H1212.09v47.69a23.29,23.29,0,0,0,23.12,23.12h184.62v45.16H1235.21c-37.57,0-67.92-30.71-67.92-68.28V1134.71C1167.29,1097.14,1197.64,1066.43,1235.21,1066.43Z",
    transform: "translate(-99.31 -477.92)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "ad71b99e-12d5-49cc-ad98-499eb0fc03f3",
    "data-name": "nameD",
    className: "f8b12798-c6e2-40ac-a3d0-6225d73b34e3",
    d: "M1582.05,1066.79l-126.09-.36v252.9h126.45a124.17,124.17,0,0,0,88.88-37.21c2.53-2.53,5.06-5.06,7.23-7.59a125.44,125.44,0,0,0,30-81.65C1708.5,1123.15,1651.78,1066.79,1582.05,1066.79Zm0,207.74h-81.29V1112h81.29a81.29,81.29,0,0,1,0,162.58Z",
    transform: "translate(-99.31 -477.92)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "a58f3d1b-cda2-4df3-b037-de0859b8ab21",
    "data-name": "tm",
    className: "f8b12798-c6e2-40ac-a3d0-6225d73b34e3",
    d: "M1740.54,1068.89v6.94H1724.6v31.92h-6.93v-31.92h-15.94v-6.94Zm44.46-.05v38.85h-6.94v-24.75l-6.83,5.21-5.66,4.39-5.66-4.39-6.83-5.21v24.75h-6.94v-38.85l6.94,5.32,12.49,9.61,12.49-9.61Z",
    transform: "translate(-99.31 -477.92)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderLogo);
export default __webpack_public_path__ + "static/media/loader-logo.b939fd3b496e39c4cbc50f682ef68606.svg";
export { ForwardRef as ReactComponent };